const Constants = {
    MessageType: {
        CaptureScreenshot: "capture_screenshot",
        StopCaptureScreenshot: "stop_capture_screenshot",
        ReportCaptureProgress: "capture_progress",
        ReportCaptureError: "capture_error",
        ScreenshotTabReady: "screenshot_tab_ready",
        SignedInUserToken: "signed_in_user_token",
        SendUserInfoToExtension: "send_user_info_to_extension",
    },
    Keys: {
        UserInfo: "userInfoE",
    },
    // Maximum pages to take screenshot. This is to prevent huge memory usage.
    MaxNumberOfPagesForSignedUser: 64,
    MaxNumberOfPagesForNonSignedUser: 5,
    DefaultImageFormat: "jpeg",
    DefaultImageQuality: 90,
    DefaultImageMimeType: "image/jpeg",
    API_SERVER: 'https://api.gosky.fans/',
    WEB_SERVER: 'https://screenshots.gosky.fans/',
};
if (REMOTE_DEBUG) {
    Constants.API_SERVER = 'https://api.gosky.fans/';
    Constants.WEB_SERVER = 'https://screenshots-debug.gosky.fans/';
}
else if (LOCAL_DEBUG) {
    Constants.API_SERVER = 'http://localhost:8090/';
    Constants.WEB_SERVER = 'http://localhost:10001/';
}
// The error code returned from api server.
export const ErrorCodes = {
    OK: 0,
    QuotaExceeded: 100,
};
export const EventNames = {
    UserSignedIn: 'user-signin',
    UserSignedOut: 'user-signout',
    UserIconClicked: 'user-icon-clicked',
    UserProfileUpdated: 'user-profile-updated',
};
export default Constants;
